import * as React from "react";
import { Table, Typography } from "antd";
import { IGiftAndDonation } from "../../../../model/report/applicantdata/GiftAndDonation";
import NumberFormatter from "../../../../model/common/NumberFormatter";

const GiftAndDonationGrid = ({
  translate,
  data
}: {
  translate?: any;
  data?: IGiftAndDonation[];
}) => {
  const columns = [
    {
      title: translate(
        "report8.document_template.gifts_and_donations.recipient_name"
      ),
      dataIndex: "recipientName",
      key: "recipientName"
    },
    {
      title: translate(
        "report8.document_template.gifts_and_donations.giver_name"
      ),
      dataIndex: "giverName",
      key: "giverName"
    },
    {
      title: translate(
        "report8.document_template.gifts_and_donations.gift_type"
      ),
      dataIndex: "giftType",
      key: "giftType"
    },
    {
      title: translate(
        "report8.document_template.gifts_and_donations.description"
      ),
      dataIndex: "description",
      key: "giftsAndDonationsDescription"
    },
    {
      title: translate("report8.document_template.gifts_and_donations.value"),
      key: "value",
      align: "right" as "right",
      render: (record) => (
        <div>{NumberFormatter().formatReadOnlyValue(record.value)}</div>
      )
    },
    {
      title: translate(
        "report8.document_template.gifts_and_donations.recieving_date"
      ),
      dataIndex: "receivingDate",
      key: "receivingDate"
    }
  ];
  return (
    <div>
      <Typography.Title style={{ fontSize: 12, marginBottom: 20 }}>
        {translate("report8.document_template.gifts_and_donations.title")}
      </Typography.Title>
      <Table
        bordered
        dataSource={data}
        columns={columns}
        pagination={false}
        size={"small"}
        locale={{ emptyText: translate("reports.table.no_data") }}
        style={{ marginBottom: 15 }}
      />
    </div>
  );
};

export default GiftAndDonationGrid;
